import once from "lodash/once";

// Place any global deprecation warnings you wish to show here.
// Ideally, these would be shown only to those using these values but
// there are certain situations (such as with primitives) where we cannot
// hook into their usage and thus cannot know whether or not they are being used.
export const showDeprecationWarnings = once(() => {
  // Example of a global deprecation notice:
  console.warn(
    `[@granular/fabric-core] Deprecation Warning: 'regexForGetOperationFromUrl' will no
  longer be available after February 28. Please use
  'getRegexMatchingFromUrl' instead. Please check whether or not you are
  using this in your codebase as we cannot detect its usage.`,
  );
});

// Example of a targeted deprecation notice:
// export const makeHookDataDeprecationWarn = (hookName: string): (() => void) =>
//   once(() => {
//     console.warn(
//       `[@granular/fabric-core] Deprecation Warning for '${hookName}': 'dataInNextRelease' will no longer be available after December 7. Please migrate to use 'data' instead.`
//     );
//   });

export const makeHookDeprecationWarn = (
  hookName: string,
  nextHookName = hookName,
): (() => void) =>
  once(() => {
    console.warn(
      `[@granular/fabric-core] Deprecation Warning for '${hookName}'. Please migrate to use 'next.hooks.${nextHookName}' instead.`,
    );
  });

export const makeGetEnvironmentFromUrlDeprecationWarn = (): (() => void) =>
  once(() => {
    console.warn(
      `[@granular/fabric-core] Deprecation Warning for 'getEnvironmentFromUrl'. Please migrate to use 'getGranularRuntimeEnvName' instead.`,
    );
  });
